import { render, staticRenderFns } from "./common-dialog1.vue?vue&type=template&id=152713ae&"
import script from "./common-dialog1.vue?vue&type=script&lang=js&"
export * from "./common-dialog1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports